import { ThemeProvider } from "@mui/material";
import theme from "../style/theme";

export default function Icon({ icon }) {
    return <ThemeProvider theme={theme}>
        {icon}
    </ThemeProvider>
}